import { Box, Card, Paper, SvgIcon } from '@mui/material';
import MDTypography from 'components/MDTypography';
import { useNavigate } from 'react-router-dom';
import { brandColors } from 'types/colors';
import { ReactComponent as Fan } from '../../assets/images/icons/controller.svg';
import { ReactComponent as NoNetwork } from '../../assets/images/icons/NoNetwork.svg';
import SensorsIcon from '@mui/icons-material/Sensors';

const INACTIVE_TIME = 900;

export const SimpleControllerCard = props => {
  const navigate = useNavigate();

  const handleSensorClick = event => {
    if (props.onCardClick) {
      props.onCardClick(event);
    } else if (props.parentComponent === 'ManageControllersList') {
      navigate(`/manage-device/controller/${props.id}`);
    }
  };

  const now = Math.floor(Date.now() / 1000);
  const lastRecordTime = props.params?.last_record_time || 0;
  const active = now - INACTIVE_TIME < lastRecordTime;

  return (
    <Card
      onClick={handleSensorClick}
      sx={{
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.28)',
        width: {
          xs: 'fit-content',
        },
        ...(props.hoverAnimation
          ? {
              '&:hover': {
                cursor: 'pointer',
                boxShadow: '0 6px 8px rgba(0, 0, 0, 0.16)',
                transform: 'translateY(-2px)',
                transition: 'all 0.2s ease-in-out',
              },
              transition: 'all 0.2s ease-in-out',
            }
          : {}),
      }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        ml={1}
        mr={1.25}
        my={-0.5}
        sx={{
          padding: '12px 0px 4px 0px',
        }}>
        <Box className="container">
          <Box
            className="topContainer"
            sx={{
              display: 'flex',
              width: '22rem',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}>
              <Paper
                className="sensorStatusIcon"
                color={'white'}
                elevation={2}
                style={{
                  background: brandColors.BLUE,
                }}
                sx={{
                  padding: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: '3rem',
                  height: '3rem',
                }}>
                <SvgIcon
                  sx={{
                    color: '#fff',
                    scale: '2.7',
                  }}>
                  {props.deviceType.toLowerCase() === 'controller' ? <Fan className="HomeIconClass" /> : <SensorsIcon />}
                </SvgIcon>
              </Paper>
              <MDTypography
                fontSize={16}
                sx={{
                  overflowWrap: 'anywhere',
                  marginLeft: '1rem',
                  fontWeight: 'bold',
                  color: '#000',
                }}>
                {props.name ? `${props.name}` : props.id}
              </MDTypography>
            </Box>
          </Box>
          <Box
            className="location-row"
            sx={{
              marginTop: '.5rem',
              width: '19rem',
              paddingBottom: '.3rem',
              '& .location-label': { display: 'none' },
              '&:hover .location-label': { display: 'inline' },
            }}>
            <MDTypography
              fontSize={14}
              sx={{
                fontWeight: 'regular',
                color: '#000',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}>
              <Box component="span" className="location-label">
                Building:{' '}
              </Box>
              {props.building_name === null ? 'Unassigned' : props.building_name}
              {props.floorNumber === null ? (
                ''
              ) : (
                <>
                  {' / '}
                  <Box component="span" className="location-label">
                    Floor:{' '}
                  </Box>
                  {props.floorNumber}
                </>
              )}
              {props.area_name === 'floor' || !props.area_name ? (
                ''
              ) : (
                <>
                  {' / '}
                  <Box component="span" className="location-label">
                    Area:{' '}
                  </Box>
                  {props.area_name}
                </>
              )}
            </MDTypography>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};
